/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7bb590c92385fc1290ba5cd87d8cbc37>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconNew = _interopRequireDefault(require("@atlaskit/icon/components/icon-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "SpeedometerRightUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab/core/speedometer-right-up
 * Usage guidance:
 * Known uses: video is set to a faster playback speed; medium-high risk likelihood
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const SpeedometerRightUpIcon = props => /*#__PURE__*/_react.default.createElement(_iconNew.default, Object.assign({
  name: "SpeedometerRightUpIcon",
  dangerouslySetGlyph: `<path fill="currentcolor" d="M8 1c2.02 0 3.87.75 5.28 1.99l-1.39.8a6.5 6.5 0 0 0-8.37 9.92L2.48 14.8A8 8 0 0 1 8 1m7.97 7.36q.03.32.03.64a7.98 7.98 0 0 1-2.48 5.79l-1.04-1.09a6.48 6.48 0 0 0 2.01-4.49z"/><path fill="currentcolor" d="M15.736 5.9 10.44 8.955a2.5 2.5 0 1 1-.75-1.299L14.986 4.6zM8.866 9a1 1 0 1 0-1.733 1 1 1 0 0 0 1.733-1"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
SpeedometerRightUpIcon.displayName = 'SpeedometerRightUpIcon';
var _default = exports.default = SpeedometerRightUpIcon;